

/**
 * The ids in view order: the remembered order first (ids no longer present are
 * skipped), then every remaining id in its given (descriptor) order — so an
 * empty remembered order means pure descriptor order, and late-arriving
 * columns append without disturbing a user's re-ordering.
 */
export const orderIds = (order: readonly string[], ids: readonly string[]): readonly string[] => {
  const present = new Set(ids)
  const remembered = new Set(order)
  return [...order.filter((id) => present.has(id)), ...ids.filter((id) => !remembered.has(id))]
}

/** Move one ID to another ID's position, retaining hidden columns and identity. */
export function moveColumn(ids: readonly string[], source: string, target: string): readonly string[] {
  const from = ids.indexOf(source)
  const to = ids.indexOf(target)
  if (from < 0 || to < 0 || from === to) return ids
  const next = [...ids]
  next.splice(from, 1)
  next.splice(to, 0, source)
  return next
}
